exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.total-value[data-v-550495ba] {\n  font-size: 20px;\n  font-weight: 500;\n}\n.total-title[data-v-550495ba] {\n  font-size: 12px;\n  font-weight: 400;\n  color: #bec0ca;\n}\n.compared-value[data-v-550495ba] {\n  font-size: 10px;\n  display: inline-block;\n  margin-left: 5px;\n}\n.compared-value-positive[data-v-550495ba] {\n  color: #00bfa5;\n}\n.compared-value-negative[data-v-550495ba] {\n  color: #bf001a;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-550495ba","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/salesDashboard/subcomponents/cards/Earnings.vue
// module id = qFd1
// module chunks = 0